import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCellularDataOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconCellularDataOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-cellular-data-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L10 10.7071V15.25L10.0081 15.3608C10.0617 15.7225 10.3734 16 10.75 16C11.1642 16 11.5 15.6642 11.5 15.25V12.2071L13 13.7071V15.2487L13.0081 15.3595C13.0617 15.7212 13.3734 15.9987 13.75 15.9987C14.1642 15.9987 14.5 15.6629 14.5 15.2487V15.2071L17.1464 17.8536C17.3417 18.0488 17.6583 18.0488 17.8536 17.8536C18.0488 17.6583 18.0488 17.3417 17.8536 17.1464L2.85355 2.14645ZM13 10.8787V6.74998C13 6.33576 13.3358 5.99998 13.75 5.99998C14.1266 5.99998 14.4383 6.27749 14.4919 6.63915L14.5 6.74998V12.3787L13 10.8787ZM17.479 15.3576L16.0019 13.8806L16.0144 4.74951C16.0104 4.33961 16.3398 4.00409 16.75 3.99991C17.1229 3.99649 17.4344 4.26813 17.4909 4.62551L17.5 4.73511L17.4856 15.2504C17.4859 15.2868 17.4837 15.3226 17.479 15.3576ZM5.49187 12.6391C5.4383 12.2775 5.12656 12 4.75 12C4.33579 12 4 12.3358 4 12.75V15.25L4.00813 15.3608C4.0617 15.7225 4.37344 16 4.75 16C5.16421 16 5.5 15.6642 5.5 15.25V12.75L5.49187 12.6391ZM8.49187 10.6391C8.4383 10.2775 8.12656 9.99998 7.75 9.99998C7.33579 9.99998 7 10.3358 7 10.75V15.25L7.00813 15.3608C7.0617 15.7225 7.37344 16 7.75 16C8.16421 16 8.5 15.6642 8.5 15.25V10.75L8.49187 10.6391Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-cellular-data-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-cellular-data-off", "wpp-icon-cellular-data-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-cellular-data-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-cellular-data-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCellularDataOff$1);
      }
      break;
  } });
}

const WppIconCellularDataOff = WppIconCellularDataOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconCellularDataOff, defineCustomElement };
